import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { $accountByIdStore, $documentsStore, $downloadAccountDocumentStore } from '@lib/store';
import { View } from '@widgets';
import { File, Spinner } from '@shared/widgets';

export const Documents = () => {
  const accountDetailsStore = useUnit($accountByIdStore.store);
  const documentsStore = useUnit($documentsStore.store);
  const downloadDocumentStore = useUnit($downloadAccountDocumentStore.store);

  useEffect(() => {
    if (!accountDetailsStore.data) return;
    $documentsStore.events.getDocuments({ id: accountDetailsStore.data.id });
    return () => $documentsStore.events.clear();
  }, []);

  if (!accountDetailsStore.data) return null;
  return (
    <View
      loading={documentsStore.loading}
      error={documentsStore.error}
      noData={documentsStore.data.length === 0}
      noDataText='No documents found'
      onRefresh={() => $documentsStore.events.getDocuments({ id: accountDetailsStore.data!.id })}
    >
      <Spinner show={downloadDocumentStore.loading} position />
      <div className='flex flex-col gap-2'>
        {documentsStore.data.map((document) => (
          <File
            key={document.id}
            attachment={{ filename: document.type.name }}
            onDownload={() =>
              $downloadAccountDocumentStore.events.downloadDocument({ AccountId: accountDetailsStore.data!.id, DocumentId: document.id })
            }
          />
        ))}
      </div>
    </View>
  );
};
